export default function Mustache$getValue () {
	return this.value;
}
